export const AUTHENTICATE = 'authenticate';
export const CHECK_AUTH = 'checkAuth';

export const FETCH_INITIAL_APP_DATA = 'fetchInitialAppData';

export const FETCH_USER = 'fetchUser';
export const FETCH_LANGUAGES = 'fetchLanguages';
export const FETCH_PAGES = 'fetchPages';
export const FETCH_IMAGES = 'fetchImages';
